import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
import studioname from "../../assets/Images/studioname.png";


const WorkGroupName = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Group Name</h1>
                <p>This was the process of choosing our studio's name</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-group-name">
                    <div className="content-work-group-name-text">
                        <h1>Our Studio Name</h1>
                        <p> We had brainstorm through out week1 and week2 and finally decided to use Octolume as our name, at first our group name was octonova, 
                            but we asked for feedback, and we were told that NOVA is a common name used in these past semester, the teachers wants us to be unique. </p>

                        <p>So we look for words that still connect with supernova, which is light. and I found an idea to put a greek words into this. I thought about using "Lumos" so OctoLumos.</p>
                        <p>But then I thought about a better name which is Octolume, our group name holds a great value that means we as an octopus would light our clients way with our light.</p>

                    </div>

                    <div className="content-work-group-name-image">
                        <img src={studioname}></img>
                    </div>
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkGroupName;